import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="spinner-screen">
      <div className="spinner-logo">AM</div>
      <div className="spinner-ring"></div>
      <div className="spinner-brand">AFILIADOS<span>MARKET</span></div>
      <div className="spinner-text">Cargando tu contenido...</div>
    </div>
  );
};

export default LoadingSpinner;